import { EmptyState } from '@sede-x/shell-ds-react-framework';
import styled from 'styled-components';

export const StyledEmptyState = styled(EmptyState)`
  .shell-text-heading {
    color: #dd1d21;
  }
`;
